import { Icon, Progress, Tag } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  font-family: 'Roboto';
  user-select: none;
  margin: 0 0 8px 0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: ${({ isRevised }) => isRevised ? '#e8f5e8' : '#ffffff'};
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 80px;
  height: auto;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #d9d9d9;
  }

  ${({ isDragging }) => isDragging && `
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
    border-color: #1890ff;
  `}
`;

export const LeftTopContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  position: absolute;
  left: 0;
  top: 0;
`;

export const RightTopContent = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  position: absolute;
  right: 5px;
  top: 0;
`;

export const SourceIconContainer = styled.div`
  background-color: #595959;
  padding: 1px 4px;
  border-radius: 3px 0px;
  font-size: 10px;
  opacity: 0;
  transition: opacity 0.2s ease;

  .lead-card-container:hover & {
    opacity: 1;
  }
`;

export const Content = styled.div`
  margin: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const MainContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  min-height: 0;
`;

export const LeadInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const DateContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: -6px;
  margin-bottom: 4px;
  margin-left: 5px;
  color: #666;
  font-size: 10px;
  width: fit-content;
  transition: margin-left 0.2s ease;

  ${Container}:hover & {
    margin-left: 20px;
  }
`;

export const CalendarIcon = styled(Icon).attrs({
  type: 'calendar',
  style: {
    color: '#666',
    fontSize: '10px',
  },
})``;

export const FormIcon = styled(Icon).attrs({
  type: 'form',
  style: {
    color: '#722ed1',
    fontSize: '12px',
  },
})`
  margin-left: 4px;
  opacity: 0.8;
`;

export const Date = styled.span`
  font-size: 10px;
  color: #666;
`;

export const CopyButton = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  position: absolute;
  padding: 0;
  right: 8px;
  top: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  .lead-card-container:hover & {
    opacity: 1;
  }

  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
`;

export const CopyIcon = styled(Icon).attrs({
  type: 'copy',
  style: {
    color: '#666',
  },
})``;

export const LeadName = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  display: block;
  margin-bottom: 4px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 24px;

  .anticon {
    margin-right: 4px;
    color: #666;
    font-size: 12px;
  }
`;

export const Value = styled.span`
  color: #118632;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  background: rgba(17, 134, 50, 0.1);
  padding: 0 4px;
  border-radius: 4px;
  height: 18px;
  line-height: 18px;
  width: fit-content;

  &::before {
    content: 'R$';
    margin-right: 2px;
    font-size: 10px;
    opacity: 0.8;
  }
`;

export const RTName = styled.span`
  font-size: 10px;
  color: #666;
  display: block;
  margin-top: 1px;
`;

export const SourceTag = styled(Tag)`
  margin-top: 4px !important;
  border-radius: 4px !important;
  padding: 0 4px !important;
  font-size: 10px !important;
  background: rgba(24, 144, 255, 0.1) !important;
  border: none !important;
  color: #1890ff !important;
`;

export const PriorityIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: ${({ priority }) => {
    switch (priority) {
      case 'high':
        return '#ff4d4f';
      case 'medium':
        return '#faad14';
      case 'low':
        return '#52c41a';
      default:
        return 'transparent';
    }
  }};
`;

export const CompanyTypeAndNecessityContainer = styled.div`
  display: flex;
  margin-top: 4px;
  gap: 4px;
  flex-wrap: wrap;
`;

export const CompanyTypeTag = styled(Tag)`
  font-size: 10px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  border-radius: 4px !important;
  background: rgba(24, 144, 255, 0.1) !important;
  border: none !important;
  color: #1890ff !important;
  height: 18px !important;
  line-height: 18px !important;

  .anticon {
    font-size: 8px;
  }
`;

export const NecessityTag = styled(Tag)`
  font-size: 10px !important;
  margin: 0 !important;
  padding: 0 4px !important;
  border-radius: 4px !important;
  border: none !important;
  height: 18px !important;
  line-height: 18px !important;

  .anticon {
    font-size: 8px;
  }
`;

export const PercentageContainer = styled.div`
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 4px;
  background: #f0f0f0;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
`;

export const ProgressStyled = styled(Progress).attrs({
  strokeColor: '#1890ff',
  showInfo: false,
  size: 'small',
})`
  .ant-progress-bg {
    height: 4px !important;
    border-radius: 0 !important;
  }
  
  .ant-progress-outer {
    height: 4px !important;
  }
  
  .ant-progress-inner {
    height: 4px !important;
    background: transparent !important;
  }
`;

export const UserAvatarContainer = styled.div`
  position: absolute;
  bottom: 6px;
  right: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 5;

  .lead-card-container:hover & {
    opacity: 1;
  }
`;

export const RatingContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 1px;
  height: 18px;
  cursor: help;

  .anticon {
    font-size: 11px;
  }
`;